module.exports = __webpack_public_path__ + "static/media/Human_ZG4874_720.38f86ad7.jpeg";